import { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { CheckCircle2, Inbox } from "lucide-react";
import { api } from "@/lib/api";
import { MediaCard } from "@/components/MediaCard";
import { ApprovalModal } from "@/components/ApprovalModal";

export default function Freigabe() {
  const { accountKey, refreshApprovals } = useOutletContext();
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(null);

  const load = () =>
    api.get("/content", { params: { account: accountKey, status: "review" } }).then(({ data }) => setItems(data));

  useEffect(() => {
    if (accountKey) load();
  }, [accountKey]);

  const handleChanged = () => {
    load();
    refreshApprovals?.();
  };

  return (
    <div className="p-6 md:p-8 max-w-[1400px] mx-auto animate-rise">
      <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-neutral-400 flex items-center gap-1.5">
        <CheckCircle2 className="h-3.5 w-3.5" /> Freigabe-Center
      </p>
      <h1 className="font-head text-4xl font-bold text-neutral-900 tracking-tighter mt-1">Wartet auf deine Freigabe</h1>
      <p className="text-sm text-neutral-400 mt-1">
        {items.length} Inhalt(e) im Review. Vorschau öffnen, prüfen, freigeben oder veröffentlichen.
      </p>

      {items.length === 0 ? (
        <div className="mt-12 flex flex-col items-center justify-center text-center py-16 rounded-2xl border border-dashed border-neutral-300 bg-white/60">
          <div className="h-14 w-14 rounded-full bg-green-50 flex items-center justify-center">
            <Inbox className="h-7 w-7 text-green-600" />
          </div>
          <h3 className="font-head font-semibold text-neutral-800 mt-4">Alles freigegeben</h3>
          <p className="text-sm text-neutral-400 mt-1">Aktuell wartet kein Inhalt auf eine Freigabe.</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 mt-6">
          {items.map((item) => (
            <MediaCard key={item.id} item={item} onClick={() => setActive(item)} />
          ))}
        </div>
      )}

      <ApprovalModal item={active} onClose={() => setActive(null)} onChanged={handleChanged} />
    </div>
  );
}
